// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2o963","legacyBtn":"MutateMid_legacyBtn__3q9LC"};